/* GOODIEBOX: request larger CBB product images and stack card info under each image */
(function () {
  var IMAGE_WIDTH = "1200";
  var IMAGE_SELECTOR = ".cbb-frequently-bought-product-image";
  var CONTAINER_SELECTOR = ".cbb-frequently-bought-container";

  function toWideUrl(url) {
    if (!url || url === "none") return "";
    var next = url.replace(/_\d+x\d+(?=\.[a-zA-Z0-9]+(?:\?|$))/g, "");
    if (/[?&]width=/i.test(next)) {
      next = next.replace(/([?&])width=\d+/gi, "$1width=" + IMAGE_WIDTH);
    } else {
      next += (next.indexOf("?") === -1 ? "?" : "&") + "width=" + IMAGE_WIDTH;
    }
    next = next.replace(/([?&])height=\d+/gi, "$1height=" + IMAGE_WIDTH);
    return next;
  }

  function readUrl(background) {
    if (!background || background === "none") return "";
    var match = background.match(/url\(\s*(['"]?)(.*?)\1\s*\)/i);
    return match ? match[2] : "";
  }

  function upscaleBackground(element) {
    if (!element || element.dataset.cbbUpscaling === "1") return;

    var original = readUrl(element.style.backgroundImage);
    if (!original) return;

    var wide = toWideUrl(original);
    if (!wide || wide === original || element.dataset.cbbSrc === wide) return;

    element.dataset.cbbUpscaling = "1";
    var probe = new Image();
    probe.onload = function () {
      element.style.backgroundImage = 'url("' + wide + '")';
      element.dataset.cbbSrc = wide;
      element.dataset.cbbUpscaling = "";
    };
    probe.onerror = function () {
      if (!readUrl(element.style.backgroundImage)) {
        element.style.backgroundImage = 'url("' + original + '")';
      }
      element.dataset.cbbSrc = original;
      element.dataset.cbbUpscaling = "";
    };
    probe.src = wide;
  }

  function upscaleImages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(IMAGE_SELECTOR).forEach(upscaleBackground);
  }

  function retryEmptyImages() {
    document.querySelectorAll(IMAGE_SELECTOR).forEach(function (element) {
      if (!readUrl(element.style.backgroundImage)) {
        upscaleBackground(element);
      }
    });
  }

  function wrapBareImage(product) {
    var image = product.querySelector(":scope > " + IMAGE_SELECTOR);
    if (!image) return;

    var frame = document.createElement("span");
    frame.className = "cbb-frequently-bought-product-image-link";
    product.insertBefore(frame, image);
    frame.appendChild(image);
  }

  function layoutCards(container) {
    if (!container) return;

    var title = container.querySelector(".cbb-frequently-bought-title");
    if (title && container.firstElementChild !== title) {
      container.insertBefore(title, container.firstElementChild);
    }

    var products = container.querySelectorAll(
      ".cbb-frequently-bought-products > .cbb-frequently-bought-product:not(.cbb-frequently-bought-product-form-tile)"
    );
    var selectors = container.querySelectorAll(".cbb-frequently-bought-selector-list > li");
    var i;

    for (i = 0; i < products.length && i < selectors.length; i++) {
      if (selectors[i].parentElement !== products[i]) {
        products[i].appendChild(selectors[i]);
      }
    }

    for (i = 0; i < products.length; i++) {
      wrapBareImage(products[i]);
    }

    var form = container.querySelector(".cbb-frequently-bought-form");
    if (form && form.parentElement !== container) {
      container.appendChild(form);
    }

    var list = container.querySelector(".cbb-frequently-bought-selector-list");
    if (list && !list.children.length) {
      list.setAttribute("hidden", "");
    }
  }

  function enhance(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches(CONTAINER_SELECTOR)) {
      layoutCards(scope);
      upscaleImages(scope);
      return;
    }
    scope.querySelectorAll(CONTAINER_SELECTOR).forEach(layoutCards);
    upscaleImages(scope);
  }

  function watch() {
    enhance(document);
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === "attributes") {
          var target = mutation.target;
          if (target.matches && target.matches(IMAGE_SELECTOR)) {
            upscaleBackground(target);
          }
          continue;
        }
        var nodes = mutation.addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (
            node.matches &&
            (node.matches(CONTAINER_SELECTOR) ||
              node.matches(IMAGE_SELECTOR) ||
              node.matches(".cbb-frequently-bought-selector-list") ||
              node.matches(".cbb-frequently-bought-form"))
          ) {
            enhance(node.closest(CONTAINER_SELECTOR) || document);
          } else if (node.querySelector) {
            if (node.querySelector(CONTAINER_SELECTOR + ", " + IMAGE_SELECTOR)) {
              enhance(node);
            }
          }
        }
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style"],
    });
  }

  document.addEventListener("codeblackbelt:frequently-bought-together:rendered", function () {
    enhance(document);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watch);
  } else {
    watch();
  }

  window.addEventListener("load", function () {
    enhance(document);
    retryEmptyImages();
  });
  [400, 1200, 2500].forEach(function (delay) {
    setTimeout(function () {
      enhance(document);
      retryEmptyImages();
    }, delay);
  });
})();
